import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { LoginModel } from '../models/login.model';
import { HttpParams } from '@angular/common/http';
import { LoginResultModel } from '../models/login-result.model';
import * as crypto from 'crypto-js';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
declare var FirebasePlugin: any;

Injectable({
  providedIn: 'root'
})
@Injectable()
export class AuthService extends BaseService {


  crypt = this.Crypter('fBb5n!nWfTM?ZJ8');
  crypter = "fBb5n,nWfT/M?ZJ8";

  //decrypt = this.Decrypter('fBb5n!nWfTM?ZJ8')

  login(loginInfo: LoginModel) {
    const headers = {
      'Content-type': 'application/x-www-form-urlencoded'
    }

    const body = new HttpParams()
      .set('Username', loginInfo.Username)
      .set('Password', loginInfo.Password)
      .set('grant_type', 'password');
    return this.httpClient.post<LoginResultModel>(this.apiUrl + `token?TenantCode=${loginInfo.TenantCode}&ProductID=4&RememberMe=${loginInfo.RememberMe}`, body, { headers, withCredentials: true });
  }

  shouldRememberMe(){
    return this.httpClient.get<any>(this.getApiUrl('auth/remember-me'), { withCredentials: true });
  }

  logOut() {
    this.clearLocalStorage();
    this.router.navigate(['/login'])
  }

  logOutExpired() {
    this.clearLocalStorage();
    this.router.navigate(['/login'], { queryParams: { session_expired: true } })
  }

  getAuthorizationToken() {
    return localStorage.getItem(this.crypt('token'))
  }

  shouldForceChangePassword(): boolean {
    if (this.getData("should-force-change-password") == "1") {
      return true;
    } else {
      return false;
    }

  }

  toggleForceChangePassword(force: string) {
    this.storeData("should-force-change-password", force);
  }

  setIdentity(token: string, userName: string, roles: string, expires: string) {
    localStorage.setItem(this.crypt('token'), token);
    localStorage.setItem(this.crypt('user'), this.encrypt(userName));
    localStorage.setItem(this.crypt('roles'), this.encrypt(roles));
    localStorage.setItem(this.crypt('expires'), this.encrypt(expires));

    if (this.getRoles().length == 0)
      this.logOut();

    this.setRole(this.getRoles()[0].RoleSystemDescription);
  }

  refreshToken(){
    const refresh_token = this.getData('refresh_token');

    const body = new HttpParams()
      .set('refresh_token', refresh_token)
      .set('grant_type', 'refresh_token');
    return this.httpClient.post<LoginResultModel>(this.apiUrl + `token`, body)
      .pipe(
        map((req: LoginResultModel) => {
          this.setIdentity(req.access_token, req.user, req.role, req[".expires"]);
          
          if(req.refresh_token){
            this.storeData('refresh_token', req.refresh_token);
          }

          return req;
        }),
        // catchError( error => {
        //   return throwError( 'Something went wrong!' );
        // })
      )
  }

  setRole(role: string) {
    localStorage.setItem(this.crypt('role'), this.encrypt(role));
  }

  getUserName(): string {
    return this.decrypt(localStorage.getItem(this.crypt('user')));
  }

  getRole(): string {
    return this.decrypt(localStorage.getItem(this.crypt('role')));
  }

  hasRole(role: string): boolean {
    let roles = this.getRoles();
    return roles.filter(r => r.RoleSystemDescription == role).length > 0;
  }

  getRoles(): { Role: string, RoleSystemDescription: string }[] {
    let roles = this.decrypt(localStorage.getItem(this.crypt('roles')));
    roles = JSON.parse(roles);
    return roles;
  }

  ex() {
    // let token = localStorage.getItem('token');
    // let decodeToken = jwt_decode(token);
    //  console.log(y['sub']);
    return true;
  }

  storeData(key, value) {
    //if(value != null && value != '') //boş veri encrypt edilemiyor
    localStorage.setItem(this.crypt(key), this.encrypt(value));
  }

  getData(key) {
    var encryptedData = localStorage.getItem(this.crypt(key));
    if (encryptedData)
      return this.decrypt(encryptedData)
    else
      return '';
  }

  loggedIn() {
    if (this.getAuthorizationToken())
      return true;
    else
      return false;
  }


  ////////////////////////////////////
  controlData() {
    return this.httpClient.get(this.apiUrl + '/controlUser');

  }

  authDetails(user) {
    // http://localhost:8000/api/details
    return this.httpClient.post(this.apiUrl + '/details', user);
  }


  //https://stackoverflow.com/a/54026460/4133449
  Crypter(salt) {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);

    return text => text.split('')
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join('');
  }

  Decrypter(salt) {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
  }

  encrypt(salt) {
    //console.log(typeof salt);
    try {
      if(salt == null || salt == ''){
        return '';
      }
      
      return crypto.AES.encrypt(salt, this.crypter).toString();
    } catch (e) {
      console.log(e);
    }
  }

  decrypt(data) {
    
    try {
      const bytes = crypto.AES.decrypt(data, this.crypter);
      if (bytes.toString()) {
        return bytes.toString(crypto.enc.Utf8);
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  clearLocalStorage() {

    var topicA = localStorage.getItem("topic_user"); // Pass a key name to get its value.
    var topicB = localStorage.getItem("topic_tenant"); // Pass a key name to get its value.
    var topicC = localStorage.getItem("topic_all");

    localStorage.clear();

    localStorage.setItem("topic_user", topicA); // Pass a key name to get its value.
    localStorage.setItem("topic_tenant", topicB); // Pass a key name to get its value.
    localStorage.setItem("topic_all", topicC);

  }

  checkNotification(loginInfo: LoginResultModel) {
    if (this.isCordova) {

      var storage = window.localStorage;
      var topicA = storage.getItem("topic_user"); // Pass a key name to get its value.
      var topicB = storage.getItem("topic_tenant"); // Pass a key name to get its value.
      var topicC = storage.getItem("topic_all");
      

      if (topicA != loginInfo.topic_a){
        this.unsubscribe(topicA);
        this.subscribe("topic_user", loginInfo.topic_a);
      }

      if (topicB != loginInfo.topic_b){
        this.unsubscribe(topicB);
        this.subscribe("topic_tenant", loginInfo.topic_b);
      }

      if (topicC != loginInfo.topic_c){
        this.unsubscribe(topicC);
        this.subscribe("topic_all", loginInfo.topic_c);
      }
    }    
  }


  subscribe(key, topic){
    FirebasePlugin.subscribe(topic, function(){
        //log("Subscribed to topic");
        window.localStorage.setItem(key, topic);
    },function(error){
        //logError("Failed to subscribe to topic", error);
    });
  }

  unsubscribe(topic){
    FirebasePlugin.unsubscribe(topic, function(){
        //log("Unsubscribed from topic");
    },function(error){
        //logError("Failed to unsubscribe from topic", error);
    });
  }

}
